<template>
  <div class="autosave-indicator">
    <span
      :class="{ 'autosave-indicator__circle--saved': !isSaving }"
      class="autosave-indicator__circle"
    >
    </span>
    <span v-if="isSaving" class="autosave-indicator__label"> Saving... </span>
    <span v-if="!isSaving" class="autosave-indicator__label">
      Saved {{ lastSaveTime | saveTimeFilter }}
    </span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import types from "../store/types";
import { padTime } from "../utils";

export default {
  data() {
    return {
      hasPerformedAutosave: false,
    };
  },
  computed: {
    ...mapGetters([types.getters.isSaving, types.getters.lastSaveTime]),
  },
  filters: {
    saveTimeFilter: (date) => {
      return "";
      if (date) {
        return `at ${padTime(date.getHours())}:${padTime(date.getMinutes())}:${padTime(date.getSeconds())}`;
      }
      return "";
    },
  },
  mounted() {},
  watch: {
    isSaving(newValue, oldValue) {
      // console.log('Is saving value changed');
      this.hasPerformedAutosave = true;
    },
  },
};
</script>

<style lang="scss">
@import "../scss/color";
@import "../scss/typography";

.autosave-indicator {
  display: flex;
  margin-left: auto;
  margin-right: 24px;
  flex-direction: row;
  align-items: center;

  &__circle {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-right: 12px;
    border-radius: 32px;
    background-color: #ffbb6a;
    vertical-align: middle;

    &--saved {
      background-color: #6cdc9f;
    }
  }

  &__label {
    color: $aqua-grey-90;
    @include global-paragraph-medium-regular;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AutosaveIndicator.vue